export interface EventTag {
  id:   number;
  name: string;
  slug: string;
}

export const TAG_LABELS: Record<string, string> = {
  entrepreneurship: '起業向け',
  job_hunting:      '就活向け',
  learning:         '学習向け',
};

export type EventCategory =
  | 'company_briefing'
  | 'roundtable'
  | 'oneday_intern'
  | 'oneday_selection'
  | 'internship'
  | 'ob_og_visit';

export type LocationType = 'online' | 'offline';

export type IndustryType =
  | 'real_estate_developer'
  | 'real_estate_sales_brokerage'
  | 'real_estate_rental_brokerage'
  | 'property_management'
  | 'house_maker'
  | 'construction_general_contractor'
  | 'proptech'
  | 'architecture_interior'
  | 'real_estate_finance_reit'
  | 'other';

export type CompanyScaleType = 'large' | 'medium_large' | 'medium' | 'venture';

export interface EventData {
  id: number;
  title: string;
  description: string | null;
  category: EventCategory;
  event_date: string;
  start_time: string;
  end_time: string;
  location: string;
  location_type: LocationType;
  capacity: number;
  current_participants?: number;
  unread_notification_count?: number;
  company_name: string;
  industry: IndustryType | null;
  company_scale: CompanyScaleType | null;
  application_deadline: string | null;
  is_participated: boolean;
  is_past: boolean;
  tags?: EventTag[];
  meeting_url?: string | null;
  created_by?: number;
  creator_type?: 'admin' | 'company';
  is_own_company?: boolean;
  created_at: string;
  updated_at?: string;
}

import type { CalendarDot } from './calendar';
export type { CalendarDot };

export interface EventListResponse {
  events: EventData[];
  calendar_dots: CalendarDot[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
  };
}

export interface EventFilter {
  industry?: IndustryType;
  company_scale?: CompanyScaleType;
  category?: EventCategory;
  creator_type?: 'admin' | 'company';
  tag_slug?: string;
  own_only?: 'own' | 'other';
}

export interface GetEventsQuery extends EventFilter {
  year?: number;
  month?: number;
  date?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  limit?: number;
  past_only?: boolean;
}

// ─── Label maps ───────────────────────────────────────────────────

export const CATEGORY_LABELS: Record<EventCategory, string> = {
  company_briefing: '企業説明会',
  roundtable:       '座談会',
  oneday_intern:    '1dayインターン',
  oneday_selection: '1day選考会',
  internship:       'インターンシップ',
  ob_og_visit:      'OB/OG訪問会',
};

export const INDUSTRY_LABELS: Record<IndustryType, string> = {
  real_estate_developer:           '不動産デベロッパー',
  real_estate_sales_brokerage:     '不動産仲介（売買）',
  real_estate_rental_brokerage:    '不動産仲介（賃貸）',
  property_management:             '不動産管理・PM',
  house_maker:                     'ハウスメーカー',
  construction_general_contractor: '建設・ゼネコン',
  proptech:                        '不動産テック（PropTech）',
  architecture_interior:           '建築設計・インテリア',
  real_estate_finance_reit:        '不動産金融・REIT',
  other:                           'その他',
};

export const COMPANY_SCALE_LABELS: Record<CompanyScaleType, string> = {
  large:        '大企業（1000人以上）',
  medium_large: '中堅企業（300〜999人）',
  medium:       '中小企業（100〜299人）',
  venture:      'ベンチャー（100人未満）',
};

export const LOCATION_TYPE_LABELS: Record<LocationType, string> = {
  online:  'オンライン',
  offline: 'オフライン',
};

export const CATEGORY_COLORS: Record<EventCategory, string> = {
  company_briefing: '#1565C0',
  roundtable:       '#558B2F',
  oneday_intern:    '#E65100',
  oneday_selection: '#6A1B9A',
  internship:       '#00695C',
  ob_og_visit:      '#AD1457',
};
